var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import { Component, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import styles from "./styles.module.css";
let Catalogue = class Catalogue extends Vue {
  render() {
    const h = arguments[0];
    return h("div", {
      "ref": "catalogueContainer",
      "class": "ucd-listWithCatalogue-catalogue"
    }, [this.groups.map(group => {
      const className = ['ucd-listWithCatalogue-catalogue-item'];
      if (this.activeGroup === group) {
        className.push('isActive');
      }
      return h("div", {
        "ref": "catalogueElements",
        "key": group,
        "attrs": {
          "data-group": "group",
          "title": "group",
          "data-ucd-report-eid": "group"
        },
        "class": className.join(' '),
        "on": {
          "click": () => {
            this.gotoGroup(group);
          }
        }
      }, [group]);
    }), this.renderSlots()]);
  }
  gotoGroup(group) {
    this.$emit('gotoGroup', group);
  }
  renderSlots() {
    const h = this.$createElement;
    const {
      componentCatalogueFooter
    } = this.designer.$scopedSlots;
    return h("div", {
      "ref": "catalogueFooter",
      "class": styles.footer
    }, [componentCatalogueFooter === null || componentCatalogueFooter === void 0 ? void 0 : componentCatalogueFooter({
      designer: this.designer,
      uc: this.designer.uc
    })]);
  }
};
Catalogue = __decorate([Component({
  name: 'Catalogue',
  props: {
    groups: {
      type: Array,
      default: () => []
    },
    activeGroup: {
      type: String,
      default: ''
    }
  },
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER,
      default: null
    }
  }
})], Catalogue);
export default Catalogue;
//# sourceMappingURL=catalogue.js.map
